<div class="row mt-2 drag-box">
  <div class="col-2">
    <div style="padding-left: {{20*depth}}px">{{question.type_id}}</div>
  </div>
  <div class="col-2">
    <select *ngIf="question.type_id === 'YN'" class="form-control" bkInput name="question_sub_type" [(ngModel)]="question.sub_type">
      <option value="">(none)</option>
      <option value="IFYESTHEN">If Yes Then</option>
      <option value="IFYESSKIP">If Yes Skip</option>
      <option value="IFNOTHEN">If No Then</option>
      <option value="IFNOSKIP">If No Skip</option>
    </select>
    <select *ngIf="question.type_id === 'MULTIPLE_RADIO'" class="form-control" bkInput name="question_radio_sub_type"
      [(ngModel)]="question.sub_type" (ngModelChange)="onRadioSubTypeChange(question)">
      <option *ngFor="let opt of MULTIPLE_RADIO_EVENT_DETAIL_SUB_TYPE" [value]="opt.value">{{opt.label}}</option>
    </select>
    <select *ngIf="question.type_id === 'NUMBER'" class="form-control" bkInput name="question_number_sub_type"
      [(ngModel)]="question.sub_type" (ngModelChange)="onNumberSubTypeChange(question)">
      <option *ngFor="let opt of NUMBER_SUB_TYPE" [value]="opt.value">{{opt.label || '(blank)'}}</option>
    </select>
    <select *ngIf="question.type_id === 'event_start_at'" class="form-control" bkInput name="question_date_time_sub_type"
      [(ngModel)]="question.sub_type">
      <option *ngFor="let opt of DATE_TIME_SUB_TYPE" [value]="opt.value">{{opt.label}}</option>
    </select>
    <div *ngIf="question.sub_type === 'IFYESSKIP' || question.sub_type === 'IFNOSKIP'">
      <select class="form-control mt-1" bkInput name="question_skip_screen" [(ngModel)]="question.skipScreen">
        <option *ngFor="let screen of nextScreens" [value]="screen.index">{{screen.name}}</option>
        <option value="END">END</option>
      </select>
    </div>
    <div *ngIf="question.type_id !== 'YN' && question.type_id !== 'MULTIPLE_RADIO' && question.type_id !== 'NUMBER' && question.type_id !== 'event_start_at'">{{question.sub_type}}</div>
    <div>{{getScreen()?.name}}</div>
  </div>
  <div class="col-5">
    <textarea name="question-text" class="form-control" bkInput [(ngModel)]="question.text"></textarea>
    <ng-template [ngIf]="question.type_id && question.type_id.includes('MULTI') && !hasRadioEventDetailSubType(question)">
      <p class="mb-1 mt-2"><b>Choices:</b></p>
      <textarea rows="4" cols="60" name="choices" class="form-control" bkInput [(ngModel)]="question.choices"></textarea>
    </ng-template>
    <div *ngIf="hasRadioEventDetailSubType(question)" class="mt-2">
      <b>Choices</b> <small class="text-muted">(from event detail; you may remove options only, at least one required)</small>
      <div *ngIf="getRadioChoiceList(question).length === 0" class="mt-1">
        <button type="button" bkButton size="sm" (click)="onRadioSubTypeChange(question)">Load options from event detail</button>
      </div>
      <ul class="list-group list-group-flush mt-1" *ngIf="getRadioChoiceList(question).length > 0">
        <li class="list-group-item d-flex justify-content-between align-items-center py-1" *ngFor="let choice of getRadioChoiceList(question); let i = index">
          <span>{{choice.label}}</span>
          <button type="button" bkButton kind="outlined" color="danger" size="sm" [disabled]="getRadioChoiceList(question).length <= 1"
            (click)="removeRadioChoice(question, i)" title="Remove option">×</button>
        </li>
      </ul>
      <button type="button" bkButton kind="outlined" color="secondary" size="sm" class="mt-1" *ngIf="getRadioChoiceList(question).length > 0" (click)="onRadioSubTypeChange(question)">
        Reset to full list
      </button>
    </div>
  </div>
  <div class="col-2">
    <div *ngIf="question.type_id === 'event_start_at' || question.type_id === 'venue'">
      <div class="mb-1">
        <label class="form-label me-2">Options</label>
        <select class="form-control w-auto d-inline-block" bkInput name="question_max" [(ngModel)]="question.max">
          <option [value]="v" *ngFor="let v of [1,2,3]">{{v}}</option>
        </select>
      </div>
      <div class="mb-1">
        <label class="form-label me-2">Required</label>
        <select class="form-control w-auto d-inline-block" bkInput name="question_min" [(ngModel)]="question.min">
          <option [value]="v" *ngFor="let v of [1,2,3]">{{v}}</option>
        </select>
      </div>
    </div>
    <div *ngIf="question.type_id === 'attendees'">
      <label class="form-label">Required at Submission</label>
      <input type="number" name="question_min" [(ngModel)]="question.min" class="form-control" bkInput />
    </div>
    <div *ngIf="question.type_id === 'speakers'">
      <div class="mb-1">
        <label class="form-label me-2">Options</label>
        <select class="form-control w-auto d-inline-block" bkInput name="question_max" [(ngModel)]="question.max">
          <option [value]="v" *ngFor="let v of [1,2,3,4,5]">{{v}}</option>
        </select>
      </div>
      <div class="mb-1">
        <label class="form-label me-2">Required</label>
        <select class="form-control w-auto d-inline-block" bkInput name="question_min" [(ngModel)]="question.min">
          <option [value]="v" *ngFor="let v of [0,1,2,3,4,5]">{{v}}</option>
        </select>
      </div>
    </div>
    <div *ngIf="question.type_id === 'speaker_count'">
      <select class="form-control" bkInput name="question_max" [(ngModel)]="question.max">
        <option [value]="v" *ngFor="let v of [1,2,3,4,5,6,7,8,9,10]">{{v}}</option>
      </select>
    </div>
    <div *ngIf="question.type_id === 'attendee_count_estimate'">
      <label class="form-label">Min Attendee</label>
      <select class="form-control" bkInput name="question_min_attendee" [(ngModel)]="question.min_attendee">
        <option [value]="v" *ngFor="let v of [1,2,3,4,5,6,7,8,9]">{{v}}</option>
      </select>
    </div>
    <div *ngIf="question.type_id === 'NUMBER'">
      <label class="form-label">Minimum</label>
      <div *ngIf="isNumberMinFromMeetingTypes(question)" class="form-control-plaintext text-muted">
        {{ getNumberMinFromAlignedMeetingTypes(question) }} (from aligned Event Types)
      </div>
      <select *ngIf="!isNumberMinFromMeetingTypes(question)" class="form-control" bkInput name="question_min_number" [(ngModel)]="question.min">
        <option [ngValue]="null"></option>
        <option [value]="v" *ngFor="let v of [0,1,2,3,4,5,6,7,8,9,10]">{{v}}</option>
      </select>
    </div>
    <div class="form-check" *ngIf="question.type_id === 'YN'">
      <input type="checkbox" class="form-check-input" name="question_na_{{question.rank}}" [(ngModel)]="question.na"
        id="question_na_{{question.rank}}">
      <label class="form-check-label" for="question_na_{{question.rank}}">N/A</label>
    </div>
    <div class="form-check" *ngIf="needOptionalCheckbox(question)">
      <input type="checkbox" class="form-check-input" name="question_optional_{{question.rank}}" [(ngModel)]="question.optional"
        id="question_optional_{{question.rank}}">
      <label class="form-check-label" for="question_optional_{{question.rank}}">Optional</label>
    </div>
    <div class="form-check" *ngIf="question.type_id === 'MULTIPLE_RADIO' || question.type_id === 'MULTIPLE_CHECK'">
      <input type="checkbox" class="form-check-input" name="question_other_{{question.rank}}" [(ngModel)]="question.other"
        id="question_other_{{question.rank}}">
      <label class="form-check-label" for="question_other_{{question.rank}}">Other</label>
    </div>
  </div>
  <div class="col-1">
    <div class="drag-handle" cdkDragHandle>
      <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
        <path
          d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
        </path>
        <path d="M0 0h24v24H0z" fill="none"></path>
      </svg>
    </div>
    <button type="button" bkButton color="danger" (click)="Delete()">
      <i class="fa fa-trash"></i>
    </button>
  </div>
</div>
<div *ngIf="question.sub_type=='IFYESTHEN' || question.sub_type == 'IFNOTHEN'" cdkDropList
  (cdkDropListDropped)="drop($event)">
  <ng-template ngFor let-subq let-i="index" [ngForOf]='question.subQuestions'>
    <app-request-question-row-edit [priority]="priority" [questions]="question.subQuestions" [question]="subq" [questionTypes]="questionTypes"
      [dedicatedQuestionTypes]="dedicatedQuestionTypes" [depth]="depth+1" [nextScreens]="nextScreens"
      (delete)="onDeleteQ(i)" cdkDrag [cdkDragData]="subq"></app-request-question-row-edit>
  </ng-template>
  <app-request-question-row-create [priority]="priority" [questions]="question.subQuestions" [newQuestion]="newQuestion"
    [questionTypes]="questionTypes" [dedicatedQuestionTypes]="dedicatedQuestionTypes" [nextScreens]="nextScreens"
    [depth]="depth+1"></app-request-question-row-create>
</div>